exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "team-calendar{display:block}team-calendar .filters-and-search{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;padding-top:20px;padding-bottom:25px}team-calendar .filters-and-search employee-search .employee-search-container{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/teamCalendar/teamCalendar.scss
// module id = 1289
// module chunks = 0